import { InputNumber } from 'antd';
import styled from 'styled-components';

export const PercentageInput = styled(InputNumber)<CustomProps>`
  .ant-input-number-input-wrap {
    &::after {
      top: 8px;
      right: 26px;
      line-height: 16px;
      position: absolute;
      color: #bfbfbf;
      font-size: 14px;
      content: '%';
    }
  }
`;

type CustomProps = {};
